import { Component, OnInit } from '@angular/core';
import { EventsService } from "./services/events.service";

// import { TranslateService } from '@ngx-translate/core';

/*
 * App Component
 * Top Level Component
 */
@Component({
  selector: 'app-root',
  providers: [EventsService],
  template: `
  
   <router-outlet></router-outlet>  
  `
})
export class AppComponent implements OnInit {

  name: string = '';
  url: string = '';

  constructor() {
    
  }


  ngOnInit(): any {
    return undefined;
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts